





















import {Component, Vue} from 'vue-property-decorator';

@Component({
  components: {},
})

export default class HamburgerMenu extends Vue {
  created(): void {

  }
}

